import Appointment2 from '@/components/Appointment2';
import Banner from '@/components/Banner2';
import Features from '@/components/Features';
import { FEATURES_LIST } from './index.js';
import Function from './components/Function';
export default {
  components: {
    Banner,
    Features,
    Function,
    Appointment2
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      productId: this.$productId.DA_SHU_JU.DA_SHU_JU
    };
  }
};